import { render, staticRenderFns } from "./Faqd.vue?vue&type=template&id=343e4dc3&"
import script from "./Faqd.vue?vue&type=script&lang=js&"
export * from "./Faqd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports